import styled, { css } from 'styled-components';

export const ButtonContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.antiFlashWhite};
  display: flex;
  border-radius: ${({ theme }) => theme.radius.xl};
  padding: 3px;
`;

export const ButtonItem = styled.button(
  ({ theme, selected }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 ${theme.spacing.sm};
    background-color: ${selected
      ? theme.colors.white
      : theme.colors.transparent};
    width: ${theme.width.full};
    border-radius: ${theme.radius.xl};
    height: 40px;
    border: none;
    box-shadow: ${selected ? '0px 1px 5px 0px rgba(0, 79, 73, 0.1)' : 'none'};
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  `
);
